
const filterTime = (time, type) => {
  if (time) {
    let str = time.split(" ")[0]
    let arr = str.split("-")
    if (type == "year") {
      return arr[0]
    } else if (type == "date") {
      return str
    }
    return arr[1] + '-' + arr[2]

  }
  return time
}
const filterStr = (str) => {

  return str.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, "")
}
const filterMark = (val, mark) => {
  if (mark == "") {
    return val
  }
  return val.replace(new RegExp(mark, "g"), `<span class="mark">${mark}</span>`)
}
const findAllMenuName = (id, tree) => {
  // tree为树结构的数组, nodeId为选中的某个节点
  let name = ""
  const forFn = function (arr, id) {
    arr.map((item) => {
      if (item.id === id) {
        name = item.name
      } else if (item.children && item.children.length > 0) {
        forFn(item.children, id)
      }
    })
  }
  forFn(tree, id)
  return name
}

/**
 * 导出
 **/
export {
  filterMark, filterStr, filterTime,
  findAllMenuName
}



// WEBPACK FOOTER //
// ./src/utils/utils.js